/**
 * Kill switch for Losi Arcade.
 *
 * Rage-clicks on the thinking Losi during a long reply used to open Games and
 * steal the chat. Keep the suite in-repo; flip this to re-enable later.
 */
export const LOSI_ARCADE_ENABLED = false
